import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Role } from '../../models/role';
import { environment } from 'src/environments/environment';
import { _MatSlideToggleRequiredValidatorModule } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';

const endpoint = environment.apiBaseUrl + '/admin/formulario';

@Injectable({
  providedIn: 'root'
})
export class AsistenteFormularioService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly authService: AuthService,
    private router: Router
  ) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  esAdministrador() {
    for (let role of this.authService.getUser().roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        return true;
      }
    }
    return false;
  }

  volver() {
    this.router.navigate(['/config/home']);
  }

  add(codigoAsistente, descripcion, nombre, gafuAreaFuncional, tipoFormulario, tema, idDestinatario, requiereAutenticacion) {

    const params = {
      codigoAsistente: codigoAsistente,
      descripcion: descripcion,
      nombre: nombre,
      gafuAreaFuncional: gafuAreaFuncional,
      userName: this.authService.getUser().username,
      habilitado: true,
      requiereAutenticacion: requiereAutenticacion,
      formulario: {
        tipoFormulario: tipoFormulario,
        tema: tema,
        idDestinatario: parseInt(idDestinatario as string, 10)
      }
    }

    return this.httpClient.post(`${endpoint}/add`, params)
  }

  update(idAsistente, codigoAsistente, descripcion, nombre, gafuAreaFuncional, habilitado, requiereAutenticacion, tipoFormulario, tema, idDestinatario) {

    const params = {
      idAsistente: idAsistente,
      codigoAsistente: codigoAsistente,
      descripcion: descripcion,
      nombre: nombre,
      gafuAreaFuncional: gafuAreaFuncional,
      habilitado: habilitado,
      requiereAutenticacion: requiereAutenticacion,
      userName: this.authService.getUser().username,
      formulario: {
        tipoFormulario: tipoFormulario,
        tema: tema,
        idDestinatario: parseInt(idDestinatario as string, 10)
      }
    }

    return this.httpClient.post(`${endpoint}/update`, params)
  }

  get(id) {
    return this.httpClient.get(`${endpoint}/display/${id}`)
  }

  delete(id, updateUser) {
    const params = {
      id
    }
    return this.httpClient.post(`${endpoint}/delete/${id}/${updateUser}`, params);
  }
}
